module.exports = __webpack_public_path__ + "img/qrcode-gzh.b13abe32.jpg";